import { SupplierEditContractsContainer } from 'features/edit/containers/SupplierEditContractsContainer';
import { SupplierAssignPaths } from 'features/edit/models/editModel';

export const assignRoutes = [
    {
        path: `${SupplierAssignPaths.Contracts}/:pageNumber?`,
        component: SupplierEditContractsContainer,
    },
];
